import {ValueNumber, ValueType} from "@types";
import React, {FC} from "react";
import Decimal from "decimal.js";

export type NumberTextProps = {
    type: ValueType;
    value: Decimal;
}

export const NumberText: FC<NumberTextProps | ValueNumber> = ({value, type}) => {
    switch (type) {
        case ValueType.SOL:
            return (<span>{value.toString()} SOL</span>)
        case ValueType.USD:
            return (<span>${value.toString()}</span>)
        default:
            throw Error(`Unsupported type: ${type}`);
    }
}